<template>
    <v-tab-item :value="thisTab" class="fill-height pa-16">
        <v-layout column justify-center align-center class="h-100 mx-auto" style="max-width: 1224px">
            <v-sheet style="flex: 1 1 auto; overflow-x: hidden; overflow-y: auto" class="scroll-primary px-10">
                <v-card outlined flat tile width="480px" max-width="90vw" class="py-20">
                    <v-layout justify-center align-center class="pt-16 px-16">
                        <v-icon size="80" color="primary">mdi-check-circle</v-icon>
                    </v-layout>
                    <v-card-title class="d-flex justify-center">
                        모든 서명 완료
                    </v-card-title>
                    <v-card-text class="text-center">
                        서명 완료 문서와 진행 이력이 담긴 인증서가 <br />
                        이메일로 전송되었습니다.
                    </v-card-text>
                </v-card>
            </v-sheet>
            <div class="v-btn-group flex-wrap my-12">
                <v-btn
                    color="primary"
                    class="min-w-140px min-w-lg-160px"
                    v-bind="{
                        loading,
                    }"
                    @click="$emit('exit')"
                >
                    <span> 확인 </span>
                </v-btn>
            </div>
        </v-layout>
    </v-tab-item>
</template>

<script>
import { initEmploymentContract } from "@/assets/variables";

import { TABS } from "../lib";

const thisTab = TABS.DONE.value;

export default {
    props: {
        /** @type {import('vue').PropType<import('@/assets/variables').EmploymentContract>} */
        value: { type: Object, default: initEmploymentContract },
        tab: { type: String, default: TABS.VIEW.value },
        shows: { type: Boolean, default: false },
        loading: { type: Boolean, default: false },
    },
    data: () => ({
        thisTab,
    }),
};
</script>
